import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from './styles';
import BackToList from './BackToList/BackToList';

type Props = {
  title: React.ReactNode;
  backToListLink?: boolean;
  children: React.ReactNode;
  actionPanel?: React.ReactNode;
  loading?: boolean;
  className?: string;
};

const ViewFrame = ({
  title,
  children,
  backToListLink = false,
  actionPanel,
  loading = false,
  className = '',
}: Props) => {
  const classes = useStyles();

  return (
    <div className={`${classes.container} ${className}`}>
      {(title || actionPanel || backToListLink)
      && (
        <Grid container className={classes.topPanel}>
          <Grid item className={clsx(classes.titleContainer, actionPanel ? classes.titleContainerWithActionPanel : '')}>
            {title && !loading && (<h2 className={classes.title}>{title}</h2>)}
            { !loading && backToListLink && <BackToList />}
          </Grid>
          {actionPanel && <Grid item>{actionPanel}</Grid>}
        </Grid>
      )}
      <Typography
        variant="body2"
        color="textSecondary"
        component="div"
      >
        {children}
      </Typography>
    </div>
  );
};

export default ViewFrame;
